module.exports = __webpack_public_path__ + "img/search.91a1adbd.png";